import * as React from 'react'
import './index.scss'
import { RedirectButtonProps } from './types'
import { Icon } from '@petz/ds-icon'
import { SegmentContext } from '../../hooks/SegmentContext'

export const RedirectButton: React.FC<RedirectButtonProps> = ({ title, kind, href, rightIconName, section, subSection }: RedirectButtonProps) => {
  const { segmentTrack } = React.useContext(SegmentContext)
  const safeHref = href ?? ''
  const safeKind = kind ?? 'outline'

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault()
    segmentTrack('Help Option Clicked', { widget: true, alt_text: 'ajuda-alt', help_section: section, help_subsection: subSection, button_name: title, link_url: safeHref })

    window.location.href = safeHref
  }

  return (
    <a className={`redirect-button ${safeKind}`} href={safeHref} onClick={handleClick}>
      <p className="redirect-button-text">{title}</p>
      {rightIconName ? (
        <div className="redirect-button-icon">
          <Icon name={rightIconName} variant="line" size="md" />
        </div>
      ) : null}
    </a>
  )
}
